module.exports = __webpack_public_path__ + "img/prestige-about-inactive@3x.png";